import { ReactNode, useState, useEffect, useMemo } from 'react';
import { AppStateContext, AppState } from './app_state_context';
import { logger } from '../../utilities/logger';
import { APP_EVENT } from './app_state.constants';
interface AppStateProviderProps {
  readonly children: ReactNode;
}

export function AppStateContextProvider({ children }: AppStateProviderProps) {
  // Set initial state to active when the app first mounts
  const [status, setStatus] = useState<AppState>(AppState.active);
  const [isInitialised, setIsInitialised] = useState(false);

  useEffect(() => {
    const handleWillSuspend = () => {
      logger.debug({ message: 'willSuspend event' });
      setStatus(AppState.inactive);
    };

    const handleDidResume = () => {
      logger.debug({ message: 'didResume event' });
      setStatus(AppState.active);
    };

    window.addEventListener(APP_EVENT.willSuspendEventKey, handleWillSuspend);
    window.addEventListener(APP_EVENT.didResumeEventKey, handleDidResume);

    return () => {
      window.removeEventListener(APP_EVENT.willSuspendEventKey, handleWillSuspend);
      window.removeEventListener(APP_EVENT.didResumeEventKey, handleDidResume);
    };
  }, []);

  const contextValue = useMemo(
    () => ({ status, isInitialised, setIsInitialised }),
    [status, isInitialised, setIsInitialised]
  );

  return <AppStateContext.Provider value={contextValue}>{children}</AppStateContext.Provider>;
}
